$(function() {
  
  $("#watervalHoogte").val("20");
  $("#watervalBreedte").val("20");
  $("#opvoerhoogte").val("0,5");
  $("#vijvertype").val("2");
  $("#slanglengte").val("5");
  
   $('#uvc-keuzehulp-next').on('click', function() {
     getUVCKeuze();
     getPompKeuze();
    $('#uvc-vijvertype').slideUp("slow");
    $('#conclusie').slideDown("slow");
  });
  
 $('#uvc-conclusie-previous').on('click', function() {
    $('#conclusie').slideUp("slow");
    $('#uvc-vijvertype').slideDown("slow");
  });
  
    
  $('#waterval-next').on('click', function() {
    getPompKeuze();
    $('#waterval-div').slideUp("slow");
    $('#conclusie').slideDown("slow");
  });
  
  $('#waterval-conclusie-previous').on('click', function() {
    $('#conclusie').slideUp("slow");
    $('#waterval-div').slideDown("slow");
  });
  
  
  $('#watervalHoogte').change(function(){
    calcWatervalCap();
  });
  
  $('#watervalBreedte').change(function(){
    calcWatervalCap();
  });
  
  $('#opvoerhoogte').change(function(){
  });
  
  $('#slanglengte').change(function(){
  });
  
  $('#lengte').change(function(){
    calcInhoud();
  });
  $('#breedte').change(function(){
    calcInhoud();
  });
  $('#diepte').change(function(){
    calcInhoud();
  });
  
  $('#uvc-vijvertype').change(function(){
    showDoorvoerCapaciteit();
  });
  
  $('#uvc-vijverinhoud').change(function(){
    showDoorvoerCapaciteit();
  });
  
  
  $('#filteren-box').on('click', function() {
    var checkBoxes = $("#filteren-check");
    checkBoxes.prop("checked", !checkBoxes.prop("checked"));
  });
  
  $('#beweging-box').on('click', function() {
    var checkBoxes = $("#beweging-check");
    checkBoxes.prop("checked", !checkBoxes.prop("checked"));
  });
  
  $('#overige-box').on('click', function() {
    var checkBoxes = $("#overige-check");
    checkBoxes.prop("checked", !checkBoxes.prop("checked"));
  });
    
});


function calcWatervalCap(){
    var hoogte = $('#watervalHoogte').val();
    var breedte = $('#watervalBreedte').val();
    var inhoud = 0;
    
  	var okValue = ['20','40','60','80'];
  
  if(okValue.includes(hoogte)==true && okValue.includes(breedte)==true){
    var cap = watervalCap(hoogte,breedte);
  	$('#watervaluitkomst').text(cap.toFixed(0));
    $('#nettocap').val(cap.toFixed(0));
  } else {
    $('#watervaluitkomst').text("selecteer waarde");
    $('#nettocap').val('0');
  }
}


function calcInhoud(){
    var lengte = parseInt($('#lengte').val());
    var breedte = parseInt($('#breedte').val());
    var diepte = parseInt($('#diepte').val());
    var inhoud = 0;
    
 
    if(Number.isInteger(lengte) && Number.isInteger(breedte) && Number.isInteger(diepte)){
      inhoud = lengte/100*breedte/100*diepte/100;
      $('#uitkomst').text(inhoud + " m3 / " + inhoud*1000 + " liter");
    } else {
      $('#uitkomst').text("no numbers");
    }
  }

function showProduct(prodId){
  $('#product'+prodId).show();
}

function hideProduct(prodId){
  $('#product'+prodId).hide();
}


function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }
  });
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true    // same code for prestige theme   
  }));
}


function getUVCKeuze(){
  var cap = calcDoorvoerCapaciteit();
  var capTable = {'bc18':3000,'bc36':6000,'bc55':9000};
  var typeNamen = {'bc18':'5498538360998','bc36':'5498538885286','bc55':'5498539540646'};
  
  hideProduct(typeNamen['bc18'])
  hideProduct(typeNamen['bc36'])
  hideProduct(typeNamen['bc55'])
  
  var type = 0;
  if(capTable['bc18']>=cap){
    type = 'bc18';
  } else if(capTable['bc36']>=cap){
    type = 'bc36';
  } else if(capTable['bc55']>=cap){
    type = 'bc55';
  }
  
  if(type == 0){
    //geen geschikte capaciteit
    return '';
  } else {
    //wel geschikte capaciteit
    showProduct(typeNamen[type]);
  }
}


function watervalCap(hoogte,breedte){
  var capTable = {'2020':1300,'2040':2200,'2060':3000,'2080':3600,'4020':1800,'4040':3000,'4060':4000,'4080':5000,'6020':2500,'6040':4000,'6060':5000,'6080':6000,'8020':3000,'8040':4500,'8060':6000,'8080':7500};
  var sleut = hoogte+breedte;
  return capTable[sleut];
}

function getPompKeuze(){
  var cap = $('#nettocap').val();
  var opvoerhoogte = $('#opvoerhoogte').val();
  var slanglengte = $('#slanglengte').val();
  
  var typeNamen = {'bf3000':'5498544423078','bf6000':'5498544947366','bf10000':'5498545471654','bf16000':'5498545930406'};
  
  var pompKeuze = calcPompKeuze(cap,opvoerhoogte,slanglengte);
  
  var type=pompKeuze['type'];
  var slang = pompKeuze['diameter'].join('mm, ');
  
  //toggle
  var i;
  var typeKeys = Object.keys(typeNamen);
  var n = typeKeys.length;
  for(i=0;i<n;i++){
    if(typeKeys[i]==type){
      showProduct(typeNamen[typeKeys[i]]);
    } else {
      hideProduct(typeNamen[typeKeys[i]]);
    }
  }
  $('#pompkeuzeslang').text(slang+'mm');
}

function showDoorvoerCapaciteit(){
  var cap = calcDoorvoerCapaciteit();
  $('#doorvoercapaciteit').text(cap.toFixed(0));
  $('#nettocap').val(cap.toFixed(0));

}

function calcDoorvoerCapaciteit(){
  var factor = parseFloat($('#vijvertype').val());
  var volume = parseInt($('#uvc-vijverinhoud ').val());
  return volume/factor;
}

function calcPompKeuze(cap,opvoerhoogte,slanglengte){
  var mm32 = getPompCap(opvoerhoogte,slanglengte,32);
  var mm38 = getPompCap(opvoerhoogte,slanglengte,38);
  var mm50 = getPompCap(opvoerhoogte,slanglengte,50);
  
  var bf3000check=capCheck('bf3000',cap,mm32,mm38,mm50);
  var bf6000check=capCheck('bf6000',cap,mm32,mm38,mm50);
  var bf10000check=capCheck('bf10000',cap,mm32,mm38,mm50);
  var bf16000check=capCheck('bf16000',cap,mm32,mm38,mm50);
  
  
  if(bf3000check.length>0){
    return {'type': 'bf3000', 'diameter':bf3000check};
  } else if(bf6000check.length>0){
    return {'type': 'bf6000', 'diameter':bf6000check};
  } else if(bf10000check.length>0){
    return {'type': 'bf10000', 'diameter':bf10000check};
  } else if(bf16000check.length>0){
    return {'type': 'bf16000', 'diameter':bf16000check};
  }
}

function capCheck(type,cap,mm32,mm38,mm50){
  var typeCheck = [];
  
  if(mm32[type]>=cap){
    typeCheck.push(32);
  }
  if(mm38[type]>=cap){
    typeCheck.push(38);
  }
  if(mm50[type]>=cap){
    typeCheck.push(50);
  }
  
  return typeCheck;
}

function getPompCap(opvoerhoogte,slanglengte,slangdiameter){

  var bf3000 = {'0,5-5-32':1800,'0,5-10-32':1600,'0,5-15-32':1500,'1-5-32':1400,'1-10-32':1200,'1-15-32':1140,'1,5-5-32':900,'1,5-10-32':850,'1,5-15-32':800};
  var bf6000 = {'0,5-5-32':4200,'0,5-10-32':3600,'0,5-15-32':3050,'1-5-32':3600,'1-10-32':3000,'1-15-32':2800,'1,5-5-32':3000,'1,5-10-32':2650,'1,5-15-32':2400,
                     '2-5-32':2400,'2-10-32':2250,'2-15-32':2150,'0,5-5-38':4800,'0,5-10-38':4200,'0,5-15-38':4100,'1-5-38':3900,'1-10-38':3750,'1-15-38':3450,'1,5-5-38':3300,
                     '1,5-10-38':3000,'1,5-15-38':3000,'2-5-38':2600,'2-10-38':2500,'2-15-38':2200};
  var bf10000 = {'0,5-5-32':6000,'0,5-10-32':4500,'0,5-15-32':4000,'1-5-32':5400,'1-10-32':4200,'1-15-32':3600,'1,5-5-32':4500,'1,5-10-32':3800,'1,5-15-32':3400,'2-5-32':3900,
                      '2-10-32':3600,'2-15-32':3000,'0,5-5-38':7200,'0,5-10-38':6000,'0,5-15-38':6000,'1-5-38':6000,'1-10-38':5900,'1-15-38':5300,'1,5-5-38':5100,'1,5-10-38':4800,
                      '1,5-15-38':4600,'2-5-38':4600,'2-10-38':4400,'2-15-38':4200,'0,5-5-50':8400,'0,5-10-50':7800,'0,5-15-50':7200,'1-5-50':7200,'1-10-50':6900,'1-15-50':6100,
                      '1,5-5-50':6000,'1,5-10-50':5800,'1,5-15-50':4900,'2-5-50':4800,'2-10-50':4600,'2-15-50':4400};
  var bf16000 = {'0,5-5-38':10500,'0,5-10-38':9200,'0,5-15-38':8500,'1-5-38':9200,'1-10-38':8600,'1-15-38':7800,'1,5-5-38':8400,'1,5-10-38':7800,'1,5-15-38':7200,'2-5-38':7600,
                      '2-10-38':6900,'2-15-38':6000,'0,5-5-50':12500,'0,5-10-50':11900,'0,5-15-50':11000,'1-5-50':11000,'1-10-50':10500,'1-15-50':10200,'1,5-5-50':10000,'1,5-10-50':9700,
                      '1,5-15-50':9000,'2-5-50':9000,'2-10-50':8700,'2-15-50':9000}
  
  var bf3000cap=0;
  var bf6000cap=0;
  var bf10000cap=0;
  var bf16000cap=0;
  
  var sleut = opvoerhoogte+'-'+slanglengte+'-'+slangdiameter;
  
  
  //calc capaciteit bluflow3000
  if(sleut in bf3000){
    var bf3000cap=bf3000[sleut];
  }
  
  if(sleut in bf6000){
    var bf6000cap=bf6000[sleut];
  }
  
  if(sleut in bf10000){
    var bf10000cap=bf10000[sleut];
  }
  
  if(sleut in bf16000){
    var bf16000cap=bf16000[sleut];
  }
  var ret={'bf3000': bf3000cap, 'bf6000': bf6000cap, 'bf10000': bf10000cap, 'bf16000':bf16000cap};
  return ret;
}

